interface IPageTitleProps {
  children: React.ReactNode;
}

const PageTitle: React.FunctionComponent<IPageTitleProps> = ({ children }) => {
  return <h2 className="text-3xl font-semibold">{children}</h2>;
};

export default PageTitle;
